var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStickIcSnowMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6079 0C15.6425 0 14.8599 0.78264 14.8599 1.74807V12.3867L7.3371 4.86395C6.65443 4.18128 5.54761 4.18128 4.86495 4.86395C4.18228 5.54661 4.18228 6.65343 4.86495 7.3361L12.3872 14.8584H1.74807C0.782639 14.8584 4.22006e-08 15.641 0 16.6065C-4.22006e-08 17.5719 0.782638 18.3545 1.74807 18.3545H12.3872L4.86444 25.8773C4.18177 26.5599 4.18177 27.6667 4.86444 28.3494C5.5471 29.0321 6.65392 29.0321 7.33659 28.3494L14.8599 20.8261V31.4653C14.8599 32.4307 15.6425 33.2134 16.6079 33.2134C17.5734 33.2134 18.356 32.4307 18.356 31.4653V20.8272L25.8782 28.3494C26.5609 29.032 27.6677 29.032 28.3504 28.3494C29.033 27.6667 29.033 26.5599 28.3504 25.8772L20.8277 18.3545H31.4653C32.4307 18.3545 33.2134 17.5719 33.2134 16.6065C33.2134 15.641 32.4307 14.8584 31.4653 14.8584H20.8276L28.3498 7.33615C29.0325 6.65349 29.0325 5.54667 28.3498 4.864C27.6672 4.18134 26.5604 4.18134 25.8777 4.864L18.356 12.3857V1.74807C18.356 0.782639 17.5734 0 16.6079 0Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickIcSnowMobile);
export default __webpack_public_path__ + "static/media/stick-ic-snow-mobile.b1d7b73ab65bf93cd4b7f886aadb7b0a.svg";
export { ForwardRef as ReactComponent };